import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/**
 * What is waiting to be stored: received goods, or picked goods going back.
 * With `key`, only that row: the one a task of the tray points to.
 *
 * @param {{source: 'receiving'|'restock', page?: number, key?: string}} params
 */
export const getPutawayPendingRequest = (warehouseId, { source, page = 1, key }) =>
  api.get(warehousePath(warehouseId, 'putaway/pending/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { source, page, ...(key ? { key } : {}) },
  });

/** Stores received goods: `{bucket_id | product_id | product_code, to_slot_code, quantity, idempotency_key}`. */
export const putawayRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'putaway/'), body, OPERATOR_REQUEST_CONFIG);

/** Stores goods coming back from an order: `{order_product_id, to_slot_code, quantity, lot?, idempotency_key}`. */
export const restockRequest = (warehouseId, body) =>
  api.post(warehousePath(warehouseId, 'putaway/restock/'), body, OPERATOR_REQUEST_CONFIG);
